import React from 'react';
import { Link } from 'react-router-dom';
import type { BusinessListing } from '../../types';

interface FormBusinessHeaderProps {
  listing: BusinessListing;
}

export function FormBusinessHeader({ listing }: FormBusinessHeaderProps) {
  return (
    <div className="bg-site-bg border-b border-site-border">
      <div className="flex items-center justify-center gap-3 px-4 py-4">
        <Link to="/" className="flex items-center gap-3 no-underline hover:opacity-80 transition-opacity">
          {listing.logo_url && (
            <img
              src={listing.logo_url}
              alt={listing.business_name}
              className="w-10 h-10 rounded-lg object-contain"
            />
          )}
          <span className="text-lg font-semibold text-site-text">
            {listing.business_name}
          </span>
        </Link>
      </div>
    </div>
  );
}
